import { useContext } from 'react';
import Button from '../../../../components/Button';
import CancelButton from '../../../../components/CancelButton';
import InputField from '../../../../components/InputField';
import LanguageField from '../../../../components/LanguageField';
import LocaleField from '../../../../components/LocaleField';
import { CountryCodeField, PhoneInputField } from '../../../../components/PhoneInputField';
import TimezoneField from '../../../../components/TimezoneField';
import LegalNameVerification from '../../../../components/LegalNameVerification';
import GeneralEditContext from './GeneralEditContext';
import { mobileCSS, mobilePhoneNumberFieldCSS } from './generalEditCSS';

const GeneralEditMobile = () => {
    const {
        countries,
        countryCode,
        countryCodeError,
        enableUserProfileStandardization,
        fieldLabels: {
            cancelLabel,
            countryCodeLabel,
            firstNameLabel,
            languageLabel,
            lastNameLabel,
            localeLabel,
            middleNameLabel,
            mobilePhoneLabel,
            prefixLabel,
            saveLabel,
            suffixLabel,
            timezoneLabel,
        },
        firstName,
        language,
        lastName,
        legalNameVerified,
        locale,
        middleName,
        onCancel,
        onCountryCodeChange,
        onFirstNameChange,
        onLanguageChange,
        onLastNameChange,
        onLegalNameVerifiedChange,
        onLocaleChange,
        onMiddleNameChange,
        onPhoneChange,
        onPrefixChange,
        onSave,
        onSuffixChange,
        onTimezoneChange,
        options,
        phone,
        phoneDisabled,
        phoneError,
        prefix,
        saveButtonDisabled,
        suffix,
        timezone,
    } = useContext(GeneralEditContext);

    const { languages, locales, timezones } = options;

    return (
        <div css={mobileCSS}>
            {enableUserProfileStandardization && (
                <InputField label={prefixLabel} value={prefix} onChange={onPrefixChange} />
            )}
            <InputField
                label={`${firstNameLabel}*`}
                value={firstName}
                onChange={onFirstNameChange}
            />
            {enableUserProfileStandardization && (
                <InputField
                    label={middleNameLabel}
                    value={middleName}
                    onChange={onMiddleNameChange}
                />
            )}
            <InputField label={`${lastNameLabel}*`} value={lastName} onChange={onLastNameChange} />
            {enableUserProfileStandardization && (
                <InputField label={suffixLabel} value={suffix} onChange={onSuffixChange} />
            )}
            <div css={mobilePhoneNumberFieldCSS}>
                <CountryCodeField
                    countries={countries}
                    label={countryCodeLabel}
                    value={countryCode}
                    onChange={onCountryCodeChange}
                    errorMessage={countryCodeError}
                />
                <PhoneInputField
                    label={mobilePhoneLabel}
                    value={phone}
                    onChange={onPhoneChange}
                    errorMessage={phoneError}
                    disabled={phoneDisabled}
                />
            </div>
            <LanguageField
                label={languageLabel}
                languages={languages}
                onChange={onLanguageChange}
                value={language}
            />
            <LocaleField
                label={localeLabel}
                locales={locales}
                onChange={onLocaleChange}
                value={locale}
            />
            <TimezoneField
                label={timezoneLabel}
                onChange={onTimezoneChange}
                value={timezone}
                timezones={timezones}
            />
            <LegalNameVerification
                legalNameVerified={legalNameVerified}
                onChange={onLegalNameVerifiedChange}
            />
            <Button onClick={onSave} disabled={saveButtonDisabled}>
                {saveLabel}
            </Button>
            <CancelButton label={cancelLabel} onClick={onCancel} />
        </div>
    );
};

export default GeneralEditMobile;
